<template>
  <div
    class="container lms-wrapper-two"
  >
    <student-nav @route-changed="toggleNavbar(false)"></student-nav>
    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div> -->
    <div class="lms-content">
      <student-header ref="lmsv4header" class="filled" />
      <div class="lms-content-body" style="height: calc(100vh - 80px); padding: 0;">
        <div class="bg-white" 
        style="border-top: 1px solid #e1e1e1; border-left: 1px solid #e1e1e1; padding-top: 20px; padding-left: 20px; padding-right: 10px">
        
          <ul class="steps">
            <li class="step-item" :class="{ active: stepCur == 1 }">
              <a @click="stepCur = 1" href="javascript:void(0)" class="step-link">
                <span class="step-number">1</span>
                <span class="step-title">Удирдамж</span>
              </a>
            </li>
            <li class="step-item" :class="{ active: stepCur == 2 }">
              <a @click="stepCur = 2" href="javascript:void(0)" class="step-link">
                <span class="step-number">2</span>
                <span class="step-title">Хувилбар сонгох</span>
              </a>
            </li>
            <li class="step-item" :class="{ active: stepCur == 3 }">
              <a @click="stepCur = stepCur>1 ? 3 : stepCur " href="javascript:void(0)" class="step-link">
                <span class="step-number">3</span>
                <span class="step-title">Ёс зүйн тайлан илгээх</span>
              </a>
            </li>
          </ul>
          <div v-if="ethiConfig.rdy" class="card mg-t-20" style="border: none">
            <div v-if="stepCur == 1" class="pd-10">
              <div style="height: calc(100vh - 240px); overflow-y: auto;">
                <udirdamj />
              </div>
              
              <div class="d-flex align-items-center bd-t" style="padding-top: 10px;">
                
                <div class="mg-l-auto">
                  <!-- @click="videoNext()" -->
                  <button
                    @click="firstStepClick()"
                    class="btn btn-xs btn-primary btn-uppercase"
                    role="button"
                  >
                    {{ ethicModel.obj.planTypeId>0?'Тайлан харах':'Хувилбар сонгох' }}
                    <feather type="arrow-right"></feather>
                  </button>
                </div>
              </div>
            </div>
            <div v-else-if="stepCur == 2" class="pd-10">
              <div style="height: calc(100vh - 140px); overflow-y: auto;" class="d-flex align-items-center">
                <!-- <h3 class="mg-t-25 mg-b-25">Хувилбар сонгох</h3> -->
                
                <div class="row">
                  <div class="col-sm-6 col-lg-3 offset-lg-3">
                    <div class="card card-help">
                      <div class="card-body tx-13">
                        <div style="margin-bottom: 20px">
                          <div style="font-size: 20px; font-weight: bold;">А</div>
                        </div>
                        <p class="tx-color-03 mg-b-0">Байгууллагад харьяалагдан ажиллаж байгаа <span style="font-weight: bold; color: #2856a8 !important">МНБ гишүүний</span> Ёс зүйн мэдэгдэл</p>
                      </div><!-- card-body -->
                      <div @click="chooseHuvilbar(1)" class="card-footer tx-13 hover:bg-gray-100" role="button">
                        <span class="">Сонгох</span>
                        <a href="javascript:void(0)" class="tx-18 lh-0">
                          <feather type="arrow-right"></feather>
                        </a>
                      </div><!-- card-footer -->
                    </div><!-- card -->
                  </div><!-- col -->
                  <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-0">
                    <div class="card card-help">
                      <div class="card-body tx-13">
                        
                        <div style="margin-bottom: 20px">
                          <div style="font-size: 20px; font-weight: bold;">Б</div>
                        </div>
                        <p class="tx-color-03 mg-b-0">Мэргэжлийн үйлчилгээ үзүүлж байгаа <span style="font-weight: bold; color: #2856a8 !important">МНБ, аудитор</span>-н Ёс зүйн мэдэгдэл</p>
                      </div><!-- card-body -->
                      <div @click="chooseHuvilbar(2)" class="card-footer tx-13 hover:bg-gray-100" role="button">
                        <span>Сонгох</span>
                        <a href="javascript:void(0)" class="tx-18 lh-0">
                          <feather type="arrow-right"></feather>
                        </a>
                      </div><!-- card-footer -->
                    </div><!-- card -->
                  </div><!-- col -->
                </div>


              </div>
              <!-- <exam-fill
                v-if="ethiConfig.rdy"
                :ethicReportConfig="ethiConfig.obj.ethicReportConfig"
                :propExamId="ethiConfig.obj.examId"
                :propCourseId="ethiConfig.obj.ethicReportConfig.id"
                @on-congrats="examCongrats"
              /> -->
            </div>
            <div v-else-if="stepCur == 3">
              <div
                class="row no-gutters"
              >
                <div class="col-sm-8 bd-r">
                  <div class="pd-20 overflow-y-auto" style="height: 70vh">
                    <table class="table table-bordered">
                      <thead class="font-bold" style="font-weight: 700;">
                        <tr>
                          <th>№</th>
                          <th>Ёс зүйн шаардлагууд</th>
                          <th style="line-height: 1.1;">Шаардлагыг хангасан эсэх</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(task, i) in asuultuud" :key="i" class="hover:bg-gray-50">
                          <td>{{ i+1 }}</td>
                          <td>
                            <div class="leading-tight mb-2">
                              {{ task.task }}
                            </div>
                            <ol v-if="task.st1 || task.st2" class="italic leading-none text-gray-900">
                                <li v-if="task.st1" class="flex gap-1 mb-1">
                                  <div>i.</div> {{ task.st1 }}
                                </li>
                                <li v-if="task.st2" class="flex gap-1">
                                  <div>ii.</div> {{ task.st2 }}
                                </li>
                            </ol>
                          </td>
                          <td class=" space-y-2 p-1 text-xs">
                            <div @click="setField(task, 1)" class="flex items-center gap-1 cursor-pointer">
                              <div>
                                <feather :type="getAsuultIcon(task.taskEn, 1)" style="width: 16px; height: 16px;"></feather>
                              </div>
                              <span>A. Тийм</span>
                            </div>
                            <div @click="setField(task, 2)" class="d-flex align-items-center gap-1 cursor-pointer">
                              <div>
                                <feather :type="getAsuultIcon(task.taskEn, 2)" style="width: 16px; height: 16px;"></feather>
                              </div>
                              <span>B. Үгүй</span>
                            </div>
                            <div v-if="task.isRepeat" @click="setField(task, 3)" class="flex items-center gap-1 cursor-pointer">
                              <div>
                                <feather :type="getAsuultIcon(task.taskEn, 3)" style="width: 16px; height: 16px;"></feather>
                              </div>
                              <span class="leading-none">C. Тийм тохиолдол үүсээгүй</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>  

                    <div class="d-flex align-items-center">
                      <div class="pd-r-10">
                        <div class="alert alert-info" role="alert" style="margin-bottom: 0;">
                          Ёс зүйгээ дээдлэн ажиллаж байгаа МНБ гишүүн танд амжилт хүсье!
                        </div>
                      </div>
                      <div>
                        <button 
                          v-if="!alreadySent"
                          @click="finishEthic()"
                          class="btn btn-xs btn-block btn-primary btn-uppercase"
                          role="button"
                        >
                          Ёс зүйн тайланг илгээх
                          <feather type="send"></feather>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <go-points :hideBorder="true" :hidePrint="true" />
                </div>
                <!-- <div class="mg-l-auto">
                  <button
                    @click="videoNext()"
                    class="btn btn-xs btn-primary btn-uppercase"
                    role="button"
                  >
                    Бататгах шалгалт
                    <feather type="arrow-right"></feather>
                  </button>
                </div> -->
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="ethiConfigModal" title="Танилцуулга видео" hide-footer>
      <div>
        <file-preview v-if="ethiConfig.rdy"
                  :id="ethiConfig.obj.fileId"
                  :force="true"
                  :minusHeight="220"
                />
      </div>
    </b-modal>

    <b-modal v-model="thanksModal" title="Амжилттай" hide-footer centered>
      <div>
        <div>
          “Нягтлан бодох бүртгэлийн мэргэжлийн бусдаас ялгарах шинж чанар нь нийтийн эрх ашгийн төлөө үйлчлэх үүрэг хариуцлагаа ойлгон ухамсарлах явдал юм. Мэргэжлийн ёс зүйг дээдлэн ажиллаж буй Монгол улсын мэргэшсэн нягтлан бодогч танд баярлалаа”
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import "element-ui/lib/theme-chalk/index.css";
import { Select, Option, Notification } from "element-ui";

const moment = require("moment");

export default {
  components: {
    Select,
    Option,
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examFill: () => ({
      component: import("@/views/main/exam.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    udirdamj: () => ({
      component: import("@/views/modules/lms/student/pages/membership/ethicMnbi/udirdamj.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      alreadySent: false,
      thanksModal: false,
      huvilbar: null,
      asuultuud: [],
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0,
      },
      ethiConfigModal: false,
      ethiConfig: {
        obj: {},
        rdy: false,
      },
      stepCur: 1,
      hrm: {
        obj: {},
        types: [],
        rdy: false,
      },
      ethicModel: {
        obj: {
          id: 0,
        },
        rdy: false,
      },
      b: {},
      parentTask: {},
      
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();

    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    firstStepClick() {
      if(this.ethicModel.obj.planTypeId>0){
        this.stepCur++;
        this.chooseHuvilbar(this.ethicModel.obj.planTypeId);
      }else{
        this.stepCur++;
      }
    },
    getAsuultIcon(taskEn, value) {
      if (this.ethicModel.obj[taskEn] && this.ethicModel.obj[taskEn] == value) {
        return "check-circle";
      }
      return "circle";
    },
    setField(task, value) {
      if(this.thanksModal) {
        return;
      }
      this.ethicModel.obj[task.taskEn] = value;
      // console.log('setField=> ', task, field);
    },
    chooseHuvilbar(huvilbar) {
      // alert(huvilbar);
      let self = this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.huvilbar = huvilbar;
      let _tpid= 0;
      // let proj = this.$store.state.app.groupDefaultProjects.filter((x) => x.objectTypeId == 635 );
      // if (proj.length) { _tpid = proj[0].id; }
      // console.log('chooseHuvilbar=> ', _tpid);

      let _locTypeId= this.huvilbar == 1 ? 583441 : 583442;

      if(this.ethicModel.obj.planTypeId>0 && this.ethicModel.obj.planTypeId!==this.huvilbar){
        _locTypeId= this.ethicModel.obj.planTypeId == 1 ? 583441 : 583442;
      }

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          // projectId: _tpid,
          ot: 635,
          skip: 0,
          size: 100,
          model: { 
            isPublic: true, 
            locTypeId: _locTypeId
          }
          // model: {`
            // locTypeCode: this.huvilbar == 1 ? 583441 : 583442
          // },
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        // console.log('chooseHuvilbar=> ', res);
        if (res != false) {
          this.asuultuud = _.orderBy(res.data.tasks, "ord", "asc");

          if(this.ethicModel.obj.planTypeId<=0){
            this.asuultuud.forEach(x => {
              self.ethicModel.obj[x.taskEn] = null;
            });

            this.ethicModel.obj.planTypeId = this.huvilbar;
          }else{
            this.alreadySent = true;
          }

          this.stepCur++;

        }
      });

      
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },
    init() {
      request({
        api: { method: "get", url: "member/getEthicReportConfig" },
        store: this.$store,
      }).then((res) => {
        // console.log('getEthicReportConfig=> ', res);
        if (res != false) {
          //console.log('getEthicReportConfig=> ', res);
          // if (res.data.hasConfig) {
            this.ethiConfig.obj = res.data;

            this.ethiConfigModal=true;

            this.$nextTick(() => {
              this.ethiConfig.rdy = true;
              this.initTypes();
              // this.initProfile();
              this.initEthicInfo();
            });
            
          // } else {
          //   alert("Тайлант хугацаа болоогүй байна.");
          //   //this.$Notice.warning({ title: "Тайлант хугацаа болоогүй байна."});
          // }
          // let _b= res.data.task.b.filter(x=>x.ot==280);
          // if(_b!=undefined && _b.length>0){
          //   this.initBox(_b[0].id);
          // }
        }
      });
    },
    initTypes() {
      request({
        api: { method: "GET", url: "Type/getTreeData" },
        params: {
          key: "stptpCRM",
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.hrm.types = res.data.types;
        }
      });
    },
    initProfile() {
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: this.$store.state.user.userInfo.profileId,
          objectTypeId: 138,
          parentId: 0,
          userId: this.$store.state.user.userId,
        },
        store: this.$store,
      }).then((res) => {
        // console.log('initProfile=> ', res, this.$store.state.user.userInfo.profileId, this.$store.state.user.userId);
        if (res != false) {
          this.hrm.obj = res.data.task;
          this.hrm.rdy = true;
          //console.log(res);
        }
      });
    },
    initEthicInfo() {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: {
          id: this.$store.state.user.userInfo.profileId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let b = res.data.task.b.filter((x) => x.ot == 268);
          if (b != undefined) {
            //console.log('step 1', b, b[0].id);
            request({
              api: { method: "GET", url: "task/boxInTaskList" },
              params: { id: b[0].id },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                this.b = res.data.box;
                //console.log('step 2', res.data.box, b[0].id);
                // request({
                //   api: { method: "GET", url: "task/boxInTaskList" },
                //   params:{ boxId: b[0].id, },
                //   store: this.$store
                // }).then(res => {
                //   if (res != false) {
                this.b = res.data.box;
                //console.log('step 3', res.data.box, b[0].id);

                request({
                  api: { method: "GET", url: "Task/GetInherited" },
                  params: { id: this.b.taskId },
                  store: this.$store,
                }).then((res) => {
                  if (res != false) {
                    this.parentTask = res.data.task;
                    //console.log('step 4', res.data.task);
                  }
                });

                if (res.data.tasks.length) {
                  // console.log('step 5', res.data.tasks[0]);
                  this.ethicModel.obj = res.data.tasks[0];
                }

                request({
                  api: { method: "GET", url: "Task/GetInherited" },
                  params: {
                    id: this.ethicModel.obj.id,
                    projectId: this.b.projectId,
                    parentId: this.b.taskId,
                    boxId: this.b.id,
                    objectTypeId: this.b.objectTypeId,
                    userId: this.b.parentTaskUserId,
                  },
                  store: this.$store,
                }).then((res) => {
                  // console.log('step 6', {
                  //   id: this.ethicModel.obj.id,
                  //   projectId: this.b.projectId,
                  //   parentId: this.b.taskId,
                  //   boxId: this.b.id,
                  //   objectTypeId: this.b.objectTypeId,
                  //   userId: this.b.parentTaskUserId,
                  // });
                  if (res != false) {
                    this.ethicModel.obj = res.data.task;
                    this.ethicModel.obj.task = "Ёс зүйн тайлан";
                    //console.log(this.$store.state.app.groupSettings);
                    this.ethicModel.obj.i1 = getConfigValueByKey(
                      this.$store.state.app.groupSettings,
                      "tmzPointReport"
                    );

                    // var d = new Date();
                    // var year = d.getFullYear();
                    // var month = d.getMonth();
                    // var day = d.getDate();

                    // this.ethicModel.obj.d1 = d;
                    // this.ethicModel.obj.d2 = new Date(year + 1, month, day);



                    request({
                      api: { method: "GET", url: "servertime" },
                      store: this.$store
                    }).then(res => {
                      if (res != false) {
                        // console.log('servertime=> ', res.data.now);
                        this.ethicModel.obj.d1 = res.data.now;
                        this.ethicModel.obj.d2 = moment(this.ethicModel.obj.d1).endOf('year').utc().toDate();
                      }
                    });
                  }
                });

                //}
                //});
              }
            });
          }
        }
      });
    },
    videoNext() {
      this.stepCur = 3;
      // if (this.ethiConfig.obj.examId > 0) {
      //   this.stepCur = 2;
      // } else {
      //   this.stepCur = 3;
      // }
    },

    examCongrats() {
      this.stepCur++;
    },
    finishEthic() {
      let errs = [];

      this.asuultuud.forEach((x, i) => {
        if(this.ethicModel.obj[x.taskEn] == null) {
          errs.push(i+1);
        }
      });

      if (errs.length == 0) {
        // console.log('finishEthic=> ', this.ethicModel.obj);
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: { model: this.ethicModel.obj },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            

            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "TaskInUser/shareUserToTask" },
              data: {
                userId: this.$store.state.user.userId,
                taskId: this.ethiConfig.obj.ethicReportConfig.id,
              },
              store: this.$store,
            }).then((res) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                Notification.success({
                  title: `Амжилттай`,
                  message: errs[0],
                  duration: 5000,
                  type: "success",
                  position: "top-right",
                  offset: 50,
                });

                this.thanksModal = true;
                this.alreadySent = true;
                // this.$router.push("/");
              }
            });

          }
        });
      } else {
        Notification.error({
          title: `САНАМЖ`,
          message: errs.join(' | ')+' дугаарын асуултад хариулаагүй байна. Асуултад бүрэн хариулсны дараа илгээх боломжтой.!',
          duration: 5000,
          type: "error",
          position: "top-right",
          offset: 50,
        });
      }
    },
  },
};
</script>
